/**
 * @file graphql/operator.ts
 * queries/mutations for Operator.
 *
 */

import { gql } from "@apollo/client";

export const LOAD_OPERATOR_NAME_SLUG_QUERY = gql`
  query Operator($siteName: String!) {
    operator(siteName: $siteName) {
      id
      dudaWebsite {
        id
        templateId
      }
      nameSlug
      pocketflowsAnalyticsEmbedId
    }
  }
`;

export const LOAD_OPERATOR_QUERY = gql`
  query Operator($operatorSlug: String!) {
    operator(operatorSlug: $operatorSlug) {
      id
      stripeAccountId
      name
      voicePhoneNumber
      twilioPhoneNumber
      driverStatusUpdateTextsEnabled
      widgetBannerUrl
      companyLogoUrl
      nameSlug
      generalEmail
      enableCreditCardWhenBooking
      enablePaymentElement
      requireConsentWhenBooking
      gratuityWhenBooking
      customGratuityWhenBooking
      cashGratuityWhenBooking
      gratuityOptional
      customGratuityNoMinimum
      googleTrackingId
      pocketflowsAnalyticsEmbedId
      plan
      enabledOrderTypes {
        id
        name
        slug
        category
      }
      enabledTripCategories
      pricingLayout {
        driverGratuityAmt
        driverGratuityPercent
        promoDiscountAmt
        promoDiscountPercent
        taxAmt
        taxPercent
        tollsAmt
        otherName
        otherAmt
        otherPercent
        other2Name
        other2Amt
        other2Percent
        other3Name
        other3Amt
        other3Percent
        other4Name
        other4Amt
        other4Percent
        other5Name
        other5Amt
        other5Percent
        other6Name
        other6Amt
        other6Percent
        stcAmt
        stcPercent
        creditCardServiceFeeAmt
        creditCardServiceFeePercent
        meetGreetAmt
        meetGreetAmtEnabled
        calculatedOnSubtotalItems
        subtotalOrder
        calculatedOnSubtotalOrder
      }
      driverGratuityPresets
      settings {
        id
        autoPaymentPreference
        autoPaymentDeposit {
          amt
          percent
        }
        clockType
        dateFormat
        currencyCode
        operatingCountryCode
        luggageEnabled
        memberChangedStatusTextEnabled
        tripStatusUpdateTextTo
        colorTheme
        requireConsentWhenBooking
        requireSignatureWhenBooking
        reviewSite
        reviewSiteId
        reviewSiteUrlPrefix
        reviewSiteUrlSuffix
        pricingLayout {
          driverGratuityAmt
          driverGratuityPercent
          promoDiscountAmt
          promoDiscountPercent
          taxAmt
          taxPercent
          tollsAmt
          otherName
          otherAmt
          otherPercent
          other2Name
          other2Amt
          other2Percent
          other3Name
          other3Amt
          other3Percent
          other4Name
          other4Amt
          other4Percent
          other5Name
          other5Amt
          other5Percent
          other6Name
          other6Amt
          other6Percent
          stcAmt
          stcPercent
          creditCardServiceFeeAmt
          creditCardServiceFeePercent
          meetGreetAmt
          meetGreetAmtEnabled
          calculatedOnSubtotalItems
          subtotalOrder
          calculatedOnSubtotalOrder
        }
        hasActivePromoCodes
        customerPortalQuotesVisible
        customerTripCancellationRequestEnabled
        customerPortalRestrictLocationsToOperatingCountryEnabled
        clockType
        orderTypeRequirement
      }
      dudaWebsite {
        id
        templateId
      }
    }
  }
`;

export const LOAD_SKIP_VEHICLE_ENABLED = gql`
  query Operator($operatorSlug: String!) {
    operator(operatorSlug: $operatorSlug) {
      id
      name
      settings {
        id
        skipVehicleSelectionEnabled
        skipVehicleDefaultVehicle {
          id
          capacity
          description
          name
          available
          licensePlate
          hasTripConflict
          hasUnavailabilityBlock
          baseRateAutomation {
            total
            lineItems {
              name
              description
              lineTotal
              source
            }
          }
          returnBaseRateAutomation {
            total
            lineItems {
              name
              description
              lineTotal
              source
            }
          }
          weekendHourlyCost
          weekdayHourlyCost
          weekendMinMinutes
          weekdayMinMinutes
          operator {
            id
            name
          }
          features {
            id
            name
            category
          }
          photos {
            id
            url
            photoIndex
          }
          vehicleType {
            typeName
            typeSlug
          }
          settings {
            id
            pricelessBookingEnabled
            pricelessBookingTarget
            pricelessBookingCompanies {
              id
            }
            pricelessBookingContacts {
              id
            }
            forwardFacingSeat {
              id
              type
              active
              quantity
              amt
              imageUrl
              description
            }
            rearFacingSeat {
              id
              type
              active
              quantity
              amt
              imageUrl
              description
            }
            boosterSeat {
              id
              type
              active
              quantity
              amt
              imageUrl
              description
            }
          }
        }
      }
    }
  }
`;
